// import {
//   login,
//   logout,
//   getInfo
// } from '@/api/user'
// import {
//   getToken,
//   setToken,
//   removeToken
// } from '@/utils/auth'
import store from '@/store'
// import router, {
//   resetRouter
// } from '@/router'

const state = {
  // token: getToken(),
  token: '',
  url: ''
}

const mutations = {
  // 预售商品草稿箱回显  编辑草稿箱商品
  // start
  SET_token: (state, token) => {
    state.token = token
  },
  SET_url: (state, url) => {
    state.url = url
  }

}

const actions = {
  // user login
  // login({
  //   commit
  // }, userInfo) {
  //   return new Promise((resolve, reject) => {
  //     login(userInfo).then(res => {
  //       const data = res.content.token
  //       //console.log(res.content.token)
  //       setToken(data)
  //       commit('SET_TOKEN', data)
  //       resolve(res)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
